export default "__VITE_ASSET__CWhR51SU__"